/* File: /src/pages/menue/Mnu_tools.js */

import React from "react";
import { useNavigate } from "react-router-dom";

const MnuTools = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-full text-white font-sans">
      <div className="py-12 px-4 sm:px-6 md:px-8 xl:px-12 bg-slate-900/80 backdrop-blur-md rounded-xl">
        <h1 className="text-3xl md:text-4xl font-extrabold text-emerald-400 mb-6 font-poppins tracking-tight leading-snug">
          🔧 Deine digitale Werkzeugkiste für den Karrierestart
        </h1>

        <p className="text-lg text-slate-100 text-opacity-90 mb-10 max-w-3xl">
          Stell dir vor, du bekommst nicht nur eine Plattform, sondern ein intelligentes System an die Seite gestellt, das dich versteht, dich begleitet – und dir aktiv hilft. Unsere Tools sind mehr als Funktionen: Sie sind dein persönlicher Karriere-Turbo für Deutschland.
        </p>

        <section className="mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">🔍 Für Bewerber:innen</h2>
          <ul className="list-disc list-inside text-slate-100 text-opacity-90 space-y-4">
            <li><strong>📝 Lebenslauf-Generator:</strong> Erstelle mit wenigen Klicks ein professionelles Profil – GPT hilft dir bei Formulierung, Struktur und Darstellung.</li>
            <li><strong>📄 Dokumenten-Check:</strong> Elena erkennt Lücken, Fehler, falsche Formate – und gibt dir konkrete Handlungsempfehlungen.</li>
            <li><strong>🤖 Karriere-Matching:</strong> Unsere KI schlägt dir Arbeitgeber vor, die wirklich zu deinem Profil passen. In Echtzeit.</li>
            <li><strong>🗣️ Sprachanalyse:</strong> Lade einen Text hoch – Elena sagt dir, welches Sprachniveau du schriftlich zeigst. Sofort. Kostenlos.</li>
          </ul>
        </section>

        <section className="mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">🏥 Für Arbeitgeber</h2>
          <ul className="list-disc list-inside text-slate-100 text-opacity-90 space-y-4">
            <li><strong>⚙️ Auto-Matching:</strong> Du erhältst automatisch passende Bewerbungen, bewertet und sortiert durch GPT – inklusive Priorisierung.</li>
            <li><strong>📊 Skill-Analyse:</strong> Sieh auf einen Blick, wie gut Qualifikationen, Sprachkenntnisse und Profil zur Stelle passen.</li>
            <li><strong>📬 Proaktive Vorschläge:</strong> Elena meldet sich, wenn passende Kandidat:innen gefunden wurden – ganz ohne aktives Suchen.</li>
            <li><strong>📂 Relevanz statt Masse:</strong> Du bekommst keine Datenbank – du bekommst Empfehlungen. Persönlich. Präzise.</li>
          </ul>
        </section>

        <section className="text-lg text-slate-100 text-opacity-90 max-w-3xl">
          <p>
            Alle Tools auf Experts4Germany sind GPT-gestützt, individuell lernend und auf Augenhöhe programmiert. Unsere Assistentin <strong>Elena</strong> begleitet dich durch den gesamten Prozess – sie analysiert, versteht, priorisiert und schlägt vor.
          </p>
          <p className="mt-4">
            Du brauchst keine IT-Kenntnisse – nur dein Ziel. Elena übernimmt den Rest.
          </p>
        </section>

        <div className="mt-12">
          <button
            onClick={() => navigate(-1)}
            className="bg-emerald-600/70 hover:bg-emerald-500/70 text-white font-bold text-lg rounded-xl shadow-xl px-6 py-2 transition duration-300 ease-in-out"
          >
            ⬅ Zurück
          </button>
        </div>
      </div>
    </div>
  );
};

export default MnuTools;
